import styled from 'styled-components';

export const SidebarWrapper = styled.div`
  height: 100vh;
  width: 100%;

  .ant-menu-inline {
    border-inline-end: none !important;
  }

  .ant-menu-root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .ant-menu-submenu {
      border-radius: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .ant-menu-item {
    margin-bottom: 4px !important;
    width: 100% !important;
  }

  .ant-menu-title-content {
    height: 36px !important;
    width: 100% !important;
    padding: 8px 12px 8px 0px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px !important;

    /* Mobile - 480px+ */
    @media (min-width: 480px) {
      height: 38px !important;
      padding: 9px 14px 9px 0px !important;
      font-size: 13px !important;
    }

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      height: 40px !important;
      padding: 10px 16px 10px 0px !important;
      font-size: 14px !important;
    }

    /* Large Desktop - 1536px+ */
    @media (min-width: 1536px) {
      height: 42px !important;
      font-size: 15px !important;
    }

    .inactive-link {
      width: 100%;
      height: 100%;
      font-size: inherit !important;
      display: flex;
      align-items: center;
    }
  }
  .ant-menu-submenu-title {
    height: 36px;
    border-radius: 0;
    padding: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    /* Mobile - 480px+ */
    @media (min-width: 480px) {
      height: 38px;
    }

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      height: 40px;
    }

    /* Large Desktop - 1536px+ */
    @media (min-width: 1536px) {
      height: 42px;
    }

    .ant-menu-title-content {
      height: 100%;
    }
  }

  .ant-menu-item {
    height: 36px;
    padding: 0;
    margin: 0;
    font-size: 12px !important;
    font-weight: 400 !important;
    color: #00000073 !important;

    /* Mobile - 480px+ */
    @media (min-width: 480px) {
      height: 38px;
      font-size: 13px !important;
    }

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      height: 40px;
      font-size: 14px !important;
    }

    /* Large Desktop - 1536px+ */
    @media (min-width: 1536px) {
      height: 42px;
      font-size: 15px !important;
    }
  }
  .ant-form-item-row {
    flex: 1;
    width: 100%;
  }

  .ant-menu-item.ant-menu-item-selected {
    border-right: 2px solid rgba(237, 120, 54, 1);
    background: rgba(237, 120, 54, 0.1);
    font-weight: 700 !important;
    color: #ed7836 !important;
  }

  .ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title {
  }

  .ant-menu-item {
    border-radius: 0;
    margin: 0;
    width: 100%;
  }

  .inactive-link {
    color: inherit !important;
  }

  .ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title,
  .ant-menu-light
    > .ant-menu
    .ant-menu-submenu-selected
    > .ant-menu-submenu-title {
    font-weight: 700 !important;
  }

  .ant-menu-title-content .inactive-link {
    color: #00000073 !important;
  }

  .ant-menu-submenu-active .inactive-link.ant-menu-item-selected {
    color: #ed7836 !important;
  }

  .ant-menu-submenu-selected .inactive-link {
    color: #ed7836 !important;
  }
`;

export const NavbarWrapper = styled.div`
  background-color: #fff;

  .admin {
    height: 50px;
    display: flex;
    padding: 0 12px;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;

    /* Mobile - 480px+ */
    @media (min-width: 480px) {
      height: 60px;
      padding: 0 16px;
      gap: 16px;
    }

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      height: 70px;
      padding: 0 20px;
      gap: 18px;
    }

    /* Desktop - 1280px+ */
    @media (min-width: 1280px) {
      height: 70px;
      padding: 0 24px;
      gap: 20px;
    }

    .admin-icon img {
      width: 32px;
      height: 32px;
      transition: transform 0.2s ease;

      /* Mobile - 480px+ */
      @media (min-width: 480px) {
        width: 36px;
        height: 36px;
      }

      /* Tablet - 768px+ */
      @media (min-width: 768px) {
        width: 40px;
        height: 40px;
      }

      /* Large Desktop - 1536px+ */
      @media (min-width: 1536px) {
        width: 44px;
        height: 44px;
      }

      &:hover {
        transform: scale(1.1);
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .logout-icon img {
      width: 20px;
      height: 20px;
      transition: transform 0.2s ease;

      /* Mobile - 480px+ */
      @media (min-width: 480px) {
        width: 22px;
        height: 22px;
      }

      /* Tablet - 768px+ */
      @media (min-width: 768px) {
        width: 24px;
        height: 24px;
      }

      /* Large Desktop - 1536px+ */
      @media (min-width: 1536px) {
        width: 26px;
        height: 26px;
      }

      &:hover {
        transform: scale(1.1);
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  .text-header {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #ed7836;
    height: 44px;
    padding: 8px 12px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    border-top: 1px solid #e6ebf1;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    flex-wrap: wrap;

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      height: 52px;
      padding: 10px 20px;
      font-size: 17px !important;
      gap: 14px;
      flex-wrap: nowrap;
    }

    /* Desktop - 1280px+ */
    @media (min-width: 1280px) {
      height: 54px;
      padding: 10px 24px;
      font-size: 17px !important;
      gap: 16px;
    }

    /* Large Desktop - 1536px+ */
    @media (min-width: 1537px) {
      height: 58px;
      font-size: 22px !important;
      gap: 21px;
    }
  }

  .sub-title {
    font-size: 12px;
    font-weight: 700;
    color: #5bd4c1;

    /* Mobile - 480px+ */
    @media (min-width: 480px) {
      font-size: 13px;
    }

    /* Tablet - 768px+ */
    @media (min-width: 768px) {
      font-size: 14px;
    }

    /* Large Desktop - 1536px+ */
    @media (min-width: 1536px) {
      font-size: 15px;
    }
  }

  .sub-title::before {
    content: '';
    display: inline-block;
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background-color: #5bd4c1;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 10px;
  }

  .ant-form-item-control-input-content {
    height: 39px;
  }

  .ant-input-affix-wrapper.ant-input-outlined.ant-input-password {
    height: 39px;
  }

  .ant-row > .ant-form-item-row {
    height: 22px !important;
  }
  .ant-menu-submenu-title {
    font-weight: 700 !important;
    padding: 0 !important;
  }

  .ant-menu-submenu-title :has(.inactive-link) {
    font-weight: 700 !important;
    padding: 0 !important;
    color: inherit !important;
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    font-weight: 700 !important;
  }
`;
